import PropTypes from 'prop-types';
// For the future developers who get here:
// https://github.com/ryanflorence/react-training/blob/gh-pages/lessons/05-wrapping-dom-libs.md

import React from 'react';
import ReactDOM from 'react-dom';
import events from 'lib/events';
import 'amcharts3';
import 'amcharts3/amcharts/themes/light';

let AmCharts = window.AmCharts;

// Wrapper around AmCharts.makeChart
class AmChart extends React.Component {
  static defaultProps = {
    height: 300,
  };

  static propTypes = {
    className: PropTypes.string,
    config: PropTypes.object.isRequired,
    height: PropTypes.number,
    noData: PropTypes.node,
  };

  componentDidMount() {
    this.node = ReactDOM.findDOMNode(this); // eslint-disable-line react/no-find-dom-node

    this.localeChangeListener = events.subscribe('change.locale', this.forceUpdate);

    if (this.props.height) {
      this.setState({
        height: this.props.height,
      });
    }

    this.updateNode();
    this._chart = AmCharts.makeChart(this.node, this.props.config);
  }

  componentWillReceiveProps(nextProps) {
    this.updateNode(nextProps);
  }

  componentDidUpdate() {
    this.updateChart();
  }

  componentWillUnmount() {
    if (this._chart && this._chart.clear) {
      this._chart.clear();
    }

    if (this.localeChangeListener && this.localeChangeListener.remove) {
      this.localeChangeListener.remove();
    }

    ReactDOM.unmountComponentAtNode(this.node);
  }

  updateChart = (props = this.props) => {
    if (!this._chart) {
      return;
    }

    Object.assign(this._chart, props.config);

    this._chart.validateNow(true);

    // Certain chart types don't have this
    let isChrome = !!window.chrome && !!window.chrome.webstore;

    if (this._chart && this._chart.zoomOut && isChrome) {
      this._chart.zoomOut();
    } else {
      /*
        Fixed this based on the documentation:
        https://docs.amcharts.com/3/javascriptcharts/AmChart
      */
      this._chart.write(this.node);
    }
  };

  updateNode = (props = this.props) => {
    this.node.className = props.className || '';
    this.node.style.height = props.height + 'px';
  };

  render() {
    return <div/>;
  }
}

export default AmChart;
